import { Button } from '@mui/material';
import { Info, Trash2 } from 'react-feather';

import { TooltipInformation, TooltipApprovalInfo, CustomTableData, LinearLoading } from 'common'

export const PaymentsTable = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData 
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    // const { showForm } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllTransactions } = FetchData
    const { dataTransactions, loadingFetchTransactions } = fetchAllTransactions

    // ------------------------------------------------ Actions
    const { 
        handleClickFetchSpecificTransaction,
        handleClickDeleteTransaction
    } = Actions

    const columnConfig = [
        // { field: "idmovimiento", filter: true },
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                    //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                    const {usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                    return(
                        <>
                            <TooltipInformation
                                usuario_creo={usuario_creo}
                                fecha_creo={fecha_creo}
                                usuario_modifico={usuario_modifico}
                                fecha_modifico={fecha_modifico}
                            />
                        </>
                        
                    )
            }
        },
        { field: "movimiento_fecha", headerName: "FECHA", minWidth: 110, maxWidth: 110, filter: true },
        { 
            field: "movimiento_tipo", headerName: "TIPO", minWidth: 100, maxWidth: 100, filter: true,
            cellClass: (params) => {
                return params.value === 'EFECTIVO' ? 'bg-primary' : 'bg-secondary text-white';
            },
        },
        { field: "nombre_banco", headerName: "BANCO", minWidth: 150, maxWidth: 150, filter: true },
        { field: "boleta_numero", headerName: "BOLETA", minWidth: 200, filter: true },
        { field: "movimiento_moneda", headerName: "MONEDA", minWidth: 120, maxWidth: 120, filter: true },
        // { field: "movimiento_tipo_cambio", headerName: "CAMBIO", minWidth: 120, maxWidth: 120, filter: true },
        { field: "movimiento_quetzales", headerName: "TOTAL (Q)", minWidth: 120, maxWidth: 120, filter: true },
        { field: "movimiento_dolares", headerName: "TOTAL ($)", minWidth: 120, maxWidth: 120, filter: true },
        // { field: "movimiento_observaciones", headerName: "movimiento_observaciones", filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 175,
            maxWidth: 175,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {

                if(params.value === 'APROBADO') return 'bg-success';
                if(params.value === 'PENDIENTE') return 'bg-warning';
                if(params.value === 'RECHAZADO') return 'bg-danger';

            },
            cellRenderer: (params) => {
                // const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data

                if(params.value === 'APROBADO') return (
                    <TooltipApprovalInfo
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                        texto_approval='APROBADO'
                    />
                );

                if(params.value === 'PENDIENTE') return (
                    <TooltipApprovalInfo
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                        texto_approval='PENDIENTE'
                    />
                );

                if(params.value === 'RECHAZADO') return (
                    <TooltipApprovalInfo
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                        texto_approval='RECHAZADO'
                    />
                );

            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const {idmovimiento} = params.data
                return (
                    <Button 
                        startIcon = { <Info/>}
                        variant='contained'
                        size='small' 
                        color='success'
                        sx={{ marginRight: '8px' }}
                        onClick={() => handleClickFetchSpecificTransaction(idmovimiento, true)}
                        style={ { width: 170 } }
                        disabled={false}
                    >
                        VER INFO
                    </Button>
                )
            }
        },
    ]

    return (
        <div className='content'>
            {(loadingFetchTransactions) && (<LinearLoading />)}
            <CustomTableData 
                rowConfig={dataTransactions}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )

}
